import MKBox from "components/MKBox";

export default function ScrollDownIndicator() {
  return (
    <MKBox
      position="absolute"
      bottom={32}
      left="50%"
      sx={{
        transform: "translateX(-50%)",
        animation: "bounce 2s infinite",
        fontSize: 32,
        color: "white",
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={() => {
        document.getElementById("features").scrollIntoView({ behavior: "smooth" });
      }}
    >
      ↓
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(10px); }
        }
      `}</style>
    </MKBox>
  );
}
